import { useLazyQuery } from '@apollo/client';
import { get as dig } from 'lodash';
import useCurrentCompany from './useCurrentCompany';
import useCurrentUser from './useCurrentUser';
import PROJECT_OWNING_COLLABORATOR_QUERY from 'components/projects/collaboration/gql/ProjectOwningCollaboratorQuery.graphql';
import collabColors from 'components/projects/collaboration/collabColors';

const getContributorFromItem = (item) => {
  return dig(item, 'contributor', null);
};

const getDataFromContributor = (contributor) => {
  return {
    name: contributor.name,
    src: contributor.avatar,
  };
};

const getProjectFromRecordable = (recordable) => {
  if (!recordable) {
    return undefined;
  }
  switch (recordable.__typename) {
    case 'Project':
      return recordable;
    default:
      return dig(recordable, 'project', null);
  }
};

const getProjectFromItem = (item) => {
  switch (item.__typename) {
    case 'VoiceNote':
      return getProjectFromRecordable(item.recordable);
    case 'Comment':
      return getProjectFromRecordable(item.commentable);
    default:
      return dig(item, 'projectInfo', null);
  }
};

export default (item) => {
  const currentUser = useCurrentUser();
  const { currentCompany } = useCurrentCompany();
  const projectInfo = getProjectFromItem(item);
  const contributor = getContributorFromItem(item);
  const data = getDataFromContributor(contributor);
  const accentColor = item.accentColor;
  const [loadOwner, { called: ownerCalled, data: ownerData }] = useLazyQuery(
    PROJECT_OWNING_COLLABORATOR_QUERY,
  );
  if (contributor.id === currentUser.node_id) {
    // If the avatar is for the current user, then it's not going to be external.
    data.isExternal = false;
    return data;
  }
  if (!ownerCalled) {
    loadOwner({ variables: { id: projectInfo.id } });
  }
  const isOwner =
    dig(ownerData, 'viewer.project.owningCollaborator.id', '') ===
    contributor.companyId;
  data.isExternal = currentCompany.node_id !== contributor.companyId;
  // if we're showing an external avatar, we need to figure out which accent color to show
  if (data.isExternal) {
    if (isOwner) {
      data.color = collabColors.owner;
    } else {
      data.color = collabColors[accentColor];
    }
  }
  return data;
};
